/*    
<summary>
  This functional component "InfoPopupHOC" provides props to the child component.
  1. State "showInfoPopup" that manages the show/hide of pop up
  2. Function "InfoPopupToggleHandler" to toggle the show/hide popup state "showInfoPopup"
  Developer:Aashish Singh, Created Date:08-Aug-2023
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const InfoPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showInfoPopup,setShowInfoPopup] = useState<boolean>(false);

    const infoToggleHandler = () => {
        setShowInfoPopup(!showInfoPopup);
    }
	
	return <Component showInfoPopup={showInfoPopup} infoToggleHandler={infoToggleHandler} {...props}/>;
};

export default InfoPopupHOC;   